<template>
    <div
        class="alert alert-dismissible fade show"
        :class="`alert-${alert.data.alert_type || 'primary'}`"
        role="alert"
        v-if="show"
        style="margin-bottom: 0"
    >
        <div class="container">
            <div class="row">
                <div
                    class="col-md-12 site-bar-alert-content"
                    style="padding: 10px 25px; font-size: 1.1em"
                    :style="{
                        'text-align':
                            (alert && alert.data && alert.data.text_align) ||
                            'left',
                    }"
                >
                    <span
                        v-html="alert && alert.data && alert.data.content"
                    ></span>
                    <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                        @click.prevent="onCloseAlert"
                        v-if="alert.data.can_cancel"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
    props: ["bannerAlerts"],
    data() {
        return {
            show: false,
            alert: null,
            is_preview: false,
        };
    },
    methods: {
        onCloseAlert() {
            this.show = false;
            if (!this.is_preview) {
                Cookies.set(`slidestack_bar_alert_${this.alert.id}`, true, {
                    expires: this.alert.reopen_after || 1,
                });
            }
        },
    },
    created() {
        const {
            preview_banner_alert,
            active_banner_alerts,
            user_type: userType,
        } = this.bannerAlerts;
        // If admin user & preview banner alert exists, show it
        if (preview_banner_alert && userType === "admin-users") {
            this.alert = preview_banner_alert;
            this.show = true;
            this.is_preview = true;
            return;
        }
        // If admin user & no preview banner alert, then don't show any alert & return
        if (userType === "admin-users") return;
        // If not admin user & preview banner alert exists, show it based on following conditions
        if (
            !preview_banner_alert &&
            active_banner_alerts &&
            active_banner_alerts.length > 0 &&
            userType !== "admin-users"
        ) {
            let alertForAll = null;
            let alertForSpecific = null;
            active_banner_alerts.map(function (alert, index) {
                const hasCookie = Cookies.get(
                    `slidestack_bar_alert_${alert.id}`
                );
                if (alert.alert_for === userType && !hasCookie) {
                    alertForSpecific = alert;
                }
                if (alert.alert_for === "all-users" && !hasCookie) {
                    alertForAll = alert;
                }
            });
            if (alertForSpecific) {
                this.show = true;
                this.alert = alertForSpecific;
            } else if (alertForAll && !alertForSpecific) {
                this.show = true;
                this.alert = alertForAll;
            } else {
                this.show = false;
            }
        }
    },
};
</script>
